module.exports = __webpack_public_path__ + "img/1478131706.25554d71.jpg";